var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#AF6A34",
    d: "M16.463 0H5.638a.166.166 0 0 0-.161.17v1.187c0 .093.072.17.161.17h10.017v14.59c0 .092.073.169.162.169h1.13a.166.166 0 0 0 .162-.17V.68c0-.376-.289-.679-.646-.679m-2.585 2.714H3.538c-.358 0-.646.304-.646.679v11.253c0 .18.068.352.19.48l3.5 3.675a.7.7 0 0 0 .149.116v.04h.085q.106.042.222.043h6.84c.357 0 .646-.303.646-.679V3.393c0-.375-.288-.679-.646-.679M6.728 16.8 4.99 14.97h1.739zm6.342.674H8.021v-3.01c0-.47-.361-.85-.808-.85H4.346V4.242h8.724z"
  })));
};
export default SvgCopy;